import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button';
import * as actions from '../../store/actions/index';
import axios from 'axios';
import PropTypes from 'prop-types';
import './App.css';
import Iframe from 'react-iframe';
var httpBuildQuery = require('http-build-query');
var sha512 = require('js-sha512');
var moment = require('moment');
var QRCode = require('qrcode.react');
var checkpay;

class FPS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uniqueId: localStorage.getItem('token'),
            username: this.props.clientName,
            clientIP:'',
            value: '',
            firstname:'',
            lastname:'',
            phone:'',
            email:'',
            qrString: null,
            qrCodeUrl:'',
            merTradeNo:'',
        };
   
    }

    componentDidMount() {

        var self = this;

        let uniqueId = localStorage.getItem('token');
        let userType = '';
        if(this.props.caseData.claimantUniqueId == uniqueId){
            userType = 'claimant';
        }else if(this.props.caseData.respondentUniqueId == uniqueId){
            userType = 'respondent';
        }

        if (this.props.caseData.agreement_type == 'EstateAgentDispute'){

            if (this.props.caseData.a1 == 'sole'){
                if (this.props.caseData.a2 == 'vendor'){

                    if (userType == 'claimant'){
                        var name = (''+this.props.caseData.a3).split(' ');
                        this.setState({
                            firstname:this.props.caseData.a3,
                            lastname:name[0],
                            phone:this.props.caseData.a3c,
                            email:this.props.caseData.a3b
                        })
                    }
                    else if (userType == 'respondent'){
                        var name2 = (''+this.props.caseData.namesOfVendors[0].a4).split(' ');
                        this.setState({
                            firstname:this.props.caseData.namesOfVendors[0].a4,
                            lastname:name2[0],
                            phone:this.props.caseData.namesOfVendors[0].a11b,
                            email:this.props.caseData.namesOfVendors[0].a11a
                        })
                    }

                }
                else if (this.props.caseData.a2 == 'purchaser'){

                    if (userType == 'claimant'){
                        var name3 = (''+this.props.caseData.a3).split(' ');
                        this.setState({
                            firstname:this.props.caseData.a3,
                            lastname:name3[0],
                            phone:this.props.caseData.a3c,
                            email:this.props.caseData.a3b
                        })
                    }
                    else if (userType == 'respondent'){
                        var name4 = (''+this.props.caseData.namesOfPurchasers[0].a12a).split(' ');
                        this.setState({
                            firstname:this.props.caseData.namesOfPurchasers[0].a12a,
                            lastname:name4[0],
                            phone:this.props.caseData.namesOfPurchasers[0].a12j,
                            email:this.props.caseData.namesOfPurchasers[0].a12i
                        })
                    }

                }
            }
            else if (this.props.caseData.a1 == 'seperate'){

                if (userType == 'claimant'){
                    var name5 = (''+this.props.caseData.a3).split(' ');
                        this.setState({
                            firstname:this.props.caseData.a3,
                            lastname:name5[0],
                            phone:this.props.caseData.a3c,
                            email:this.props.caseData.a3b
                        })
                }
                else if (userType == 'respondent'){
                    var name6 = (''+this.props.caseData.namesOfA2[0].a4).split(' ');
                        this.setState({
                            firstname:this.props.caseData.namesOfA2[0].a4,
                            lastname:name6[0],
                            phone:this.props.caseData.namesOfA2[0].a11b,
                            email:this.props.caseData.namesOfA2[0].a11a
                        })
                }
                
            }
        
        }
        else if (this.props.caseData.agreement_type == 'MoneyLent'){
            if (userType == 'claimant'){
                var name7 = (''+this.props.claimant_name).split(' ');
                this.setState({
                    firstname:this.props.claimant_name,
                    lastname:name7[0],
                    phone:this.props.claimant_telephone,
                    email:this.props.claimant_email_address
                })
                
            }
            else if (userType == 'respondent'){

                var name8 = (''+this.props.respondent_name).split(' ');
                this.setState({
                    firstname:this.props.respondent_name,
                    lastname:name8[0],
                    phone:this.props.respondent_telephone,
                    email:this.props.respondent_email_address
                });

            }

        }
        else if (this.props.caseData.agreement_type == 'SalesOfGoods'){
            if (userType == 'claimant'){
                var name = (''+this.props.caseData.a1).split(' ');
                this.setState({
                    firstname:this.props.caseData.a1,
                    lastname:name[0],
                    phone:this.props.caseData.a8c,
                    email:this.props.caseData.a8b
                })
            }
            else if (userType == 'respondent'){
                var name2 = (''+this.props.caseData.a9).split(' ');
                this.setState({
                    firstname:this.props.caseData.a9,
                    lastname:name2[0],
                    phone:this.props.caseData.a16b,
                    email:this.props.caseData.a16a
                })
            }
        }
        else if (this.props.caseData.agreement_type == 'serviceDispute' || this.props.caseData.agreement_type == 'insuranceDispute'){
            if (userType == 'claimant'){
                var name = (''+this.props.caseData.a1).split(' ');
                this.setState({
                    firstname:this.props.caseData.a1,
                    lastname:name[0],
                    phone:this.props.caseData.a8c,
                    email:this.props.caseData.a8b
                })
            }
            else if (userType == 'respondent'){
                var name2 = (''+this.props.caseData.a9).split(' ');
                this.setState({
                    firstname:this.props.caseData.a9,
                    lastname:name2[0],
                    phone:this.props.caseData.a16b,
                    email:this.props.caseData.a16a
                })
            }
        }

        if (this.props.caseData.a1 == 'sole'){
            if (this.props.caseData.a2 === 'vendor'){
                
                this.setState({
                    value: parseInt(this.props.caseData.a15f)
                })
            }
            else if (this.props.caseData.a2 === 'purchaser'){
                
                this.setState({
                    value: parseInt(this.props.caseData.a16f)
                })
            }
        }
        else if (this.props.caseData.a1 == 'seperate'){
            this.setState({
                value: parseInt(this.props.caseData.a16f)
            })
        }

            var data = JSON.stringify({
                "userType": this.props.userType,
                "total": this.props.total,
                "caseId": this.props.caseData.caseId
            });

            var config = {
            method: 'post',
            url: `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/fps`,
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
            };
            
            axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
            
                if (response.data.status){
                
                    console.log('resonse: '+response.data.qrCodeStr)
                    var qrString = response.data.qrCodeStr
                    var qrCodeId = response.data.qrCodeId
                    var qrCodeUrl = response.data.url
                    self.setState({
                        qrCodeUrl: qrCodeUrl,
                        qrCodeId: qrCodeId,
                        qrString: qrString,
                        merTradeNo: response.data.merTradeNo,
                    })
                    self.checkPaymentStatus(1)
                }
                else{
                    if(response.data.status == 0){
                        alert(self.context.t('FPS is not available at the moment'));
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                alert(self.context.t('#FPS is not available at the moment'));
            });


            


    }

    componentDidUpdate() {
        
    }

    makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }

    submitHandler = (event) => {
        
        event.preventDefault();
            var timestamp = new Date();
            let uniqueId = localStorage.getItem('token');
            let userType = '';
            if(this.props.caseData.claimantUniqueId == uniqueId){
                userType = 'claimant';
            }else if(this.props.caseData.respondentUniqueId == uniqueId){
                userType = 'respondent';
            }
            var time = timestamp.getFullYear()+''+timestamp.getMonth()+''+timestamp.getDate()+''+timestamp.getHours()+''+timestamp.getMinutes()+''+timestamp.getSeconds()
            var rxd = this.makeid(5)
            console.log('rxd: '+rxd)
            var payload = {
                merchant_reference: this.props.caseId+'_'+userType+'_'+rxd,
                currency:'HKD',
                amount:this.props.total,
                customer_ip:this.state.clientIP,
                customer_first_name:this.state.firstname,
                customer_last_name:this.state.lastname,
                customer_phone:this.state.phone,
                customer_email:this.state.email,
                customer_country:'CN',
                customer_state:'HK',
                network:'Alipay',
                return_url:'https://www.hkemc.com.hk/hkemc.php'
            }

            console.log('Payment Asia payload: '+JSON.stringify(payload))
            //changed
            var url = 'https://www.hkarbsoc.org.hk/paymentasia.html'
            var newWindow = window.open(url);
            newWindow.pd = payload;
            this.checkPaymentStatus(1)
    };

    async checkPaymentStatus(trial=1){
        if (trial < 60){
            setTimeout(()=>{
                this.checkIfPaymentSuccessful(trial+1);
            },2000)
        }
    }

    checkIfPaymentSuccessful(trial){
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/fpsStatus`;
        var self = this;
        const getCaseInfoData = {
            caseId: this.props.caseId
        };
        axios.post(url, {
            'merTradeNo': this.state.merTradeNo,
            'caseId': this.props.caseId,
            'userType': self.props.userType
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            else{
                console.log('fpsStatus checking...'+response.data, response.data == 'false', response.data == false)
                if (response.data == true){
                    console.log('Payment successful')   
                     window.location.reload()
                }
                else{
                    self.checkPaymentStatus(trial + 1)
                }
            }
        })
    }
   
    handleChange(event) { 
        this.setState({value: event.target.value});
        console.log('handleChange: '+this.state.value)
    }

    render() {
        let file = __dirname + 'paymentasia.html'
        return ( 
            <div >
                {/* <QRCode value={this.state.qrString} /> */}
                
                    {this.state.qrString ? (
                    <img
                        style={{width: '20%', height: '20%'}}
                        src={this.state.qrString}
                        alt="QR Code"
                        className="w-32 h-32 border border-gray-300 rounded"
                    />
                    ) : (
                    <p>Loading FPS...</p>
                    )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        claimant_name: state.caseInfo.claimant_name,
        respondent_name: state.caseInfo.respondent_name,
        userType: state.caseInfo.userType,
        loadingCaseInfo: state.caseInfo.loading,
        clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
            getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
    }
}

FPS.contextTypes = {
    t: PropTypes.func
}

export default (connect(mapStateToProps, mapDispatchToProps)(FPS));